import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchBetaalmethodes, toggleBetaalmethode, testBetaalmethode } from './Reducers/actions';
import BetaalmethodeForm from './Components/BetaalmethodeForm';
import moment from 'moment';

const BetaalmethodesIndex = ({ 
  betaalmethodes, 
  fetchBetaalmethodes, 
  toggleBetaalmethode, 
  testBetaalmethode, 
  error, 
  testResult 
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    loadBetaalmethodes();
  }, []);

  const loadBetaalmethodes = async () => {
    setLoading(true);
    await fetchBetaalmethodes();
    setLoading(false);
  };

  const handleToggle = async (id) => {
    await toggleBetaalmethode(id);
    await loadBetaalmethodes();
  };

  const handleTest = async (id) => {
    await testBetaalmethode(id);
  };

  const handleConfigure = (provider) => {
    setSelectedProvider(provider);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setSelectedProvider(null);
    loadBetaalmethodes();
  };

  const getProviderConfig = (naam) => {
    return betaalmethodes.find(b => b.naam === naam);
  };

  if (loading) {
    return (
      <div className="box box-default">
        <div className="box-body text-center">
          <i className="fas fa-spinner fa-spin"></i> Laden...
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title">
                <i className="fas fa-credit-card me-2"></i>
                Betaalmethodes
              </h3>
            </div>
            
            <div className="box-body">
              {error && (
                <div className="alert alert-danger">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </div>
              )}

              <div className="row">
                {/* Mollie Card */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        <i className="fas fa-bolt me-2 text-primary"></i>
                        Mollie
                      </h5>
                      {getProviderConfig('mollie') && (
                        <span className={`badge ${getProviderConfig('mollie').actief ? 'bg-success' : 'bg-secondary'}`}>
                          {getProviderConfig('mollie').actief ? 'Actief' : 'Inactief'}
                        </span>
                      )}
                    </div>
                    <div className="card-body">
                      <p className="text-muted">
                        Europese online betalingsprovider met ondersteuning voor verschillende betaalmethoden.
                      </p>
                      
                      {getProviderConfig('mollie') && (
                        <div className="mb-3">
                          <small className="text-muted">
                            Laatste update: {moment(getProviderConfig('mollie').bijgewerkt).fromNow()}
                          </small>
                        </div>
                      )}

                      <div className="btn-group w-100" role="group">
                        <button 
                          className="btn btn-primary btn-sm"
                          onClick={() => handleConfigure('mollie')}
                        >
                          <i className="fas fa-cog me-1"></i>
                          Configureren
                        </button>
                        
                        {getProviderConfig('mollie') && (
                          <>
                            <button 
                              className={`btn btn-sm ${getProviderConfig('mollie').actief ? 'btn-warning' : 'btn-success'}`}
                              onClick={() => handleToggle(getProviderConfig('mollie')._id)}
                            >
                              <i className={`fas ${getProviderConfig('mollie').actief ? 'fa-pause' : 'fa-play'} me-1`}></i>
                              {getProviderConfig('mollie').actief ? 'Uitschakelen' : 'Inschakelen'}
                            </button>
                            
                            <button 
                              className="btn btn-info btn-sm"
                              onClick={() => handleTest(getProviderConfig('mollie')._id)}
                            >
                              <i className="fas fa-vial me-1"></i>
                              Testen
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Pay.nl Card */}
                <div className="col-md-6 mb-4">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">
                        <i className="fas fa-credit-card me-2 text-success"></i>
                        Pay.nl
                      </h5>
                      {getProviderConfig('paynl') && (
                        <span className={`badge ${getProviderConfig('paynl').actief ? 'bg-success' : 'bg-secondary'}`}>
                          {getProviderConfig('paynl').actief ? 'Actief' : 'Inactief'}
                        </span>
                      )}
                    </div>
                    <div className="card-body">
                      <p className="text-muted">
                        Nederlandse betalingsprovider met focus op lokale betaalmethoden.
                      </p>
                      
                      {getProviderConfig('paynl') && (
                        <div className="mb-3">
                          <small className="text-muted">
                            Laatste update: {moment(getProviderConfig('paynl').bijgewerkt).fromNow()}
                          </small>
                        </div>
                      )}

                      <div className="btn-group w-100" role="group">
                        <button 
                          className="btn btn-primary btn-sm"
                          onClick={() => handleConfigure('paynl')}
                        >
                          <i className="fas fa-cog me-1"></i>
                          Configureren
                        </button>
                        
                        {getProviderConfig('paynl') && (
                          <>
                            <button 
                              className={`btn btn-sm ${getProviderConfig('paynl').actief ? 'btn-warning' : 'btn-success'}`}
                              onClick={() => handleToggle(getProviderConfig('paynl')._id)}
                            >
                              <i className={`fas ${getProviderConfig('paynl').actief ? 'fa-pause' : 'fa-play'} me-1`}></i>
                              {getProviderConfig('paynl').actief ? 'Uitschakelen' : 'Inschakelen'}
                            </button>
                            
                            <button 
                              className="btn btn-info btn-sm"
                              onClick={() => handleTest(getProviderConfig('paynl')._id)}
                            >
                              <i className="fas fa-vial me-1"></i>
                              Testen
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Test Results */}
              {testResult && (
                <div className={`alert ${testResult.success ? 'alert-success' : 'alert-danger'}`}>
                  <i className={`fas ${testResult.success ? 'fa-check-circle' : 'fa-exclamation-circle'} me-2`}></i>
                  <strong>Test resultaat:</strong> {testResult.message}
                  
                  {/* Troubleshooting Tips */}
                  {!testResult.success && testResult.troubleshooting && (
                    <div className="mt-3">
                      <hr />
                      <h6 className="mb-2">
                        <i className="fas fa-tools me-2"></i>
                        Probleemoplossing:
                      </h6>
                      <ul className="mb-0">
                        {testResult.troubleshooting.map((tip, index) => (
                          <li key={index}>{tip}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  {/* Service Info Display (Both Mollie & Pay.nl) */}
                  {testResult.success && testResult.serviceInfo && (
                    <div className="mt-3">
                      <hr />
                      <h6 className="mb-2">
                        <i className="fas fa-info-circle me-2"></i>
                        Service Informatie:
                      </h6>
                      <div className="row">
                        {/* Mollie specific fields */}
                        {testResult.serviceInfo.organizationName && (
                          <>
                            <div className="col-md-6">
                              <small className="text-muted">Profiel Naam:</small><br />
                              <strong>{testResult.serviceInfo.organizationName}</strong>
                            </div>
                            <div className="col-md-6">
                              <small className="text-muted">Profiel ID:</small><br />
                              <strong>{testResult.serviceInfo.organizationId}</strong>
                            </div>
                            <div className="col-md-6 mt-2">
                              <small className="text-muted">Website:</small><br />
                              <strong>{testResult.serviceInfo.website}</strong>
                            </div>
                            <div className="col-md-6 mt-2">
                              <small className="text-muted">Email:</small><br />
                              <strong>{testResult.serviceInfo.email}</strong>
                            </div>
                            <div className="col-md-6 mt-2">
                              <small className="text-muted">API Key Type:</small><br />
                              <strong className={testResult.serviceInfo.apiKeyType.includes('Test') ? 'text-info' : 'text-success'}>
                                {testResult.serviceInfo.apiKeyType}
                              </strong>
                            </div>
                            <div className="col-md-6 mt-2">
                              <small className="text-muted">Profiel Status:</small><br />
                              <strong className={testResult.serviceInfo.profileStatus === 'verified' ? 'text-success' : 'text-warning'}>
                                {testResult.serviceInfo.profileStatus}
                              </strong>
                            </div>
                          </>
                        )}
                        
                        {/* Pay.nl specific fields */}
                        {testResult.serviceInfo.serviceName && (
                          <>
                            <div className="col-md-6">
                              <small className="text-muted">Service Naam:</small><br />
                              <strong>{testResult.serviceInfo.serviceName}</strong>
                            </div>
                            <div className="col-md-6">
                              <small className="text-muted">Service ID:</small><br />
                              <strong>{testResult.serviceInfo.serviceId}</strong>
                            </div>
                            <div className="col-md-6 mt-2">
                              <small className="text-muted">Terminal Code:</small><br />
                              <strong className={testResult.serviceInfo.terminalCode === 'Niet geconfigureerd' ? 'text-warning' : ''}>
                                {testResult.serviceInfo.terminalCode}
                              </strong>
                            </div>
                          </>
                        )}
                        
                        {/* Common fields */}
                        <div className="col-md-6 mt-2">
                          <small className="text-muted">Valuta:</small><br />
                          <strong>{testResult.serviceInfo.currency}</strong>
                        </div>
                        <div className="col-md-6 mt-2">
                          <small className="text-muted">Beschikbare Betaalmethoden:</small><br />
                          <strong>{testResult.serviceInfo.availablePaymentMethods || 'Niet beschikbaar'}</strong>
                        </div>
                        <div className="col-md-6 mt-2">
                          <small className="text-muted">Test Modus:</small><br />
                          <strong className={testResult.serviceInfo.testMode === 'Ja' ? 'text-info' : 'text-success'}>
                            {testResult.serviceInfo.testMode}
                          </strong>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Configuration Modal */}
      {showForm && (
        <BetaalmethodeForm
          provider={selectedProvider}
          onClose={handleFormClose}
          existingConfig={getProviderConfig(selectedProvider)}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  betaalmethodes: state.betaalmethodes?.betaalmethodes || [],
  error: state.betaalmethodes?.error,
  testResult: state.betaalmethodes?.testResult
});

export default connect(mapStateToProps, {
  fetchBetaalmethodes,
  toggleBetaalmethode,
  testBetaalmethode
})(BetaalmethodesIndex);